module.exports = __webpack_public_path__ + "static/media/axi3.11b143d1.jpg";